/**
 * @generated SignedSource<<bf3b84ff5db7fbd1354d5e5f33678352>>
 * @relayHash f211e4f25f2d5432851e491c92cdc406
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0703ec7ce014790acdd2d6795569b07a845ca7f407bc014577f6d7dd6f24ce08

import type { ConcreteRequest } from 'relay-runtime';
export type GraphStoreCypherQueryV2VersionEnum = "V2" | "V3" | "%future added value";
export type preloadRelatedContentSampleQuery$variables = {
  cypherQuery: string;
  first: number;
  queryContext: string;
  version?: GraphStoreCypherQueryV2VersionEnum | null;
};
export type preloadRelatedContentSampleQuery$data = {
  readonly graphStore_cypherQueryV2: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly columns: ReadonlyArray<{
          readonly key: string;
          readonly value: {
            readonly __typename: "GraphStoreCypherQueryV2AriNode";
            readonly id: string;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null;
        }>;
      };
    }>;
  } | null;
};
export type preloadRelatedContentSampleQuery = {
  response: preloadRelatedContentSampleQuery$data;
  variables: preloadRelatedContentSampleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cypherQuery"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryContext"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "version"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "query",
        "variableName": "cypherQuery"
      },
      {
        "kind": "Variable",
        "name": "queryContext",
        "variableName": "queryContext"
      },
      {
        "kind": "Variable",
        "name": "version",
        "variableName": "version"
      }
    ],
    "concreteType": "GraphStoreCypherQueryV2Connection",
    "kind": "LinkedField",
    "name": "graphStore_cypherQueryV2",
    "plural": false,
    "selections": [
      {
        "concreteType": "GraphStoreCypherQueryV2Edge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "GraphStoreCypherQueryV2Node",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreCypherQueryV2Column",
                "kind": "LinkedField",
                "name": "columns",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "value",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ],
                        "type": "GraphStoreCypherQueryV2AriNode"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "preloadRelatedContentSampleQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "preloadRelatedContentSampleQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "f211e4f25f2d5432851e491c92cdc406",
    "id": "0703ec7ce014790acdd2d6795569b07a845ca7f407bc014577f6d7dd6f24ce08",
    "metadata": {},
    "name": "preloadRelatedContentSampleQuery",
    "operationKind": "query",
    "text": "query preloadRelatedContentSampleQuery($cypherQuery:String!,$queryContext:String!,$version:GraphStoreCypherQueryV2VersionEnum,$first:Int!){graphStore_cypherQueryV2(query:$cypherQuery,queryContext:$queryContext,version:$version,first:$first)@optIn(to:\"GraphStoreCypherQueryV2\"){edges{node{columns{key,value{__typename,...on GraphStoreCypherQueryV2AriNode{id}}}}}}}"
  }
};
})();

(node as any).hash = "9ee274feb138005cc398fbd96e50cebf";

export default node;
